module.exports = __webpack_public_path__ + "img/medal2.87572345.png";